import { render, staticRenderFns } from "./BasicDatepicker.vue?vue&type=template&id=07a6887e&scoped=true&"
import script from "./BasicDatepicker.vue?vue&type=script&lang=js&"
export * from "./BasicDatepicker.vue?vue&type=script&lang=js&"
import style0 from "./BasicDatepicker.vue?vue&type=style&index=0&id=07a6887e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a6887e",
  null
  
)

export default component.exports